import { render } from "./InputCEP.vue?vue&type=template&id=27f458e6"
import script from "./InputCEP.vue?vue&type=script&lang=js"
export * from "./InputCEP.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__